// extracted by mini-css-extract-plugin
export default {"btnWrapper":"_77O-I","seeListingBtn":"q4ClC","title":"_1yemZ","itemCard":"_2oTyI"};